import { render, staticRenderFns } from "./incomeRecordList.vue?vue&type=template&id=057f2fc8&scoped=true&lang=pug"
import script from "./incomeRecordList.vue?vue&type=script&lang=js"
export * from "./incomeRecordList.vue?vue&type=script&lang=js"
import style0 from "./incomeRecordList.vue?vue&type=style&index=0&id=057f2fc8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "057f2fc8",
  null
  
)

export default component.exports